"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const modal_manager_1 = require("@kawaui/modal-manager");
const portal_1 = __importDefault(require("@kawaui/portal"));
const react_transition_group_1 = require("react-transition-group");
const styled_1 = require("./styled");
const Transition = ({ open, duration, onDone, children }) => {
    const timeout = {
        appear: 0,
        enter: 0,
        exit: duration,
    };
    return ((0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { mountOnEnter: true, unmountOnExit: true, appear: true, in: open, timeout, addEndListener: onDone, children: children }));
};
const Backdrop = ({ onClose, hideBackdrop, disableBackdropEvents }) => {
    const handleOuterClick = (event) => {
        event.stopPropagation();
        if (onClose)
            onClose(event);
    };
    const closeEvents = !disableBackdropEvents && {
        onClick: handleOuterClick,
        onTouchEnd: handleOuterClick,
    };
    return (0, jsx_runtime_1.jsx)(styled_1.StyledBackdrop, Object.assign({ hideBackdrop }, closeEvents));
};
const Modal = (_a) => {
    var { children, duration = 300, disableStyles, open, onClose } = _a, props = __rest(_a, ["children", "duration", "disableStyles", "open", "onClose"]);
    const { ref, onDone, container } = (0, modal_manager_1.useManager)({ open });
    const { disableBackdropEvents, disablePortal, hideBackdrop } = props, otherProps = __rest(props, ["disableBackdropEvents", "disablePortal", "hideBackdrop"]);
    return ((0, jsx_runtime_1.jsx)(portal_1.default, { disablePortal, container, children: (0, jsx_runtime_1.jsx)(Transition, { open, duration, onDone, children: (0, jsx_runtime_1.jsxs)(styled_1.StyledModal, Object.assign({ duration, ref }, otherProps, { children: [(0, jsx_runtime_1.jsx)(Backdrop, { onClose, disableBackdropEvents, hideBackdrop }), (0, jsx_runtime_1.jsx)(styled_1.StyledContent, { disableStyles, children: children })] })) }) }));
};
exports.Modal = Modal;
exports.default = Modal;
